/**
 * PriceCard - Current Price & Change Indicator
 *
 * Displays: Current price, change amount, change %, trend direction
 *
 * @version 1.0.0
 */

import React, { memo } from 'react';
import { Box, Typography } from '@mui/material';
import IndicatorCard from '../IndicatorCard';

const PriceCard = memo(({ currentState, symbol }) => {
    const price = currentState?.price;
    const change = currentState?.change || 0;
    const changePercent = currentState?.changePercent || 0;

    const isPositive = change >= 0;
    const changeColor = isPositive ? '#22c55e' : '#ef4444';
    const arrow = isPositive ? '▲' : '▼';

    // Format price based on symbol type
    const formatPrice = (val) => {
        if (!val) return '--';
        if (symbol?.includes('XAU') || symbol?.includes('XAG')) {
            return val.toFixed(2);
        }
        if (symbol?.includes('BTC') || symbol?.includes('ETH')) {
            return val.toFixed(2);
        }
        return val.toFixed(5);
    };

    const summary = (
        <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
            {/* Price */}
            <Typography
                sx={{
                    fontSize: '18px',
                    fontWeight: 700,
                    color: '#FAFAFA',
                    fontFamily: 'monospace'
                }}
            >
                {formatPrice(price)}
            </Typography>

            {/* Change */}
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
                <Typography
                    sx={{
                        fontSize: '12px',
                        fontWeight: 600,
                        color: changeColor,
                        fontFamily: 'monospace'
                    }}
                >
                    {arrow} {isPositive ? '+' : ''}{change.toFixed(2)}
                </Typography>
                <Typography
                    sx={{
                        fontSize: '10px',
                        color: changeColor,
                        opacity: 0.8
                    }}
                >
                    ({isPositive ? '+' : ''}{changePercent.toFixed(2)}%)
                </Typography>
            </Box>
        </Box>
    );

    return (
        <IndicatorCard
            title="PRICE"
            icon="💰"
            summary={summary}
            badge={symbol?.replace('_ct', '')}
            badgeColor="#3b82f6"
            status={isPositive ? 'bullish' : 'bearish'}
            defaultExpanded={false}
            collapsible={false}
        >
            {/* Expanded content - not used for price card */}
        </IndicatorCard>
    );
});

PriceCard.displayName = 'PriceCard';

export default PriceCard;
